// Stage labels and date formatting shared by Pipeline and the job page.
// Dates are compared as calendar days, not instants.

export const STAGE: Record<string, { label: string; tone?: string }> = {
    show_ready: { label: 'Show ready', tone: 'var(--good)' },
    in_production: { label: 'In production', tone: 'var(--good)' },
    ready_for_production: { label: 'Ready for production', tone: 'var(--text-secondary)' },
    pending: { label: 'Pending deal' },
    past: { label: 'Past' },
    wrapped: { label: 'Wrapped' },
    lost: { label: 'Lost', tone: 'var(--danger)' },
};
export const STAGE_ORDER = [
    'show_ready',
    'in_production',
    'ready_for_production',
    'pending',
    'past',
    'wrapped',
    'lost',
];

export const DAY = 86400000;

export const startOfToday = () => {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate()).getTime();
};

export const dayOf = (iso?: string | null) => {
    if (!iso) return null;
    /* a bare YYYY-MM-DD is a local calendar day, not UTC midnight */
    const ymd = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (ymd) return new Date(+ymd[1], +ymd[2] - 1, +ymd[3]).getTime();
    const d = new Date(iso);
    return Number.isNaN(d.getTime())
        ? null
        : new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
};

function md(t: number, withYear: boolean) {
    const d = new Date(t);
    const s = d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    return withYear ? `${s} ’${String(d.getFullYear()).slice(-2)}` : s;
}

/** Relative within a week, month-day beyond; same-month ranges collapse ("Sep 28 – 30"). */
export function dateRangeLabel(startAt?: string | null, endAt?: string | null): string {
    const s = dayOf(startAt);
    if (s === null) return 'TBD';
    const e = dayOf(endAt) ?? s;
    const today = startOfToday();
    const year = new Date(s).getFullYear() !== new Date().getFullYear();
    if (e === s) {
        const diff = Math.round((s - today) / DAY);
        if (diff === 0) return 'Today';
        if (diff === 1) return 'Tomorrow';
        if (diff === -1) return 'Yesterday';
        if (diff > 1 && diff < 7)
            return new Date(s).toLocaleDateString(undefined, { weekday: 'long' });
        return md(s, year);
    }
    const sameMonth = new Date(s).getMonth() === new Date(e).getMonth();
    return `${md(s, false)} – ${sameMonth ? new Date(e).getDate() : md(e, false)}${
        year ? ` ’${String(new Date(s).getFullYear()).slice(-2)}` : ''
    }`;
}

export const humanize = (v?: string | null) =>
    v ? v.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase()) : '';

export function timeRange(startAt?: string, endAt?: string) {
    const f = (iso: string) =>
        new Date(iso).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
    return [startAt, endAt].filter(Boolean).map((x) => f(x as string)).join(' – ');
}
